import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getOfflineVehicles = async () => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicles/offline`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch Offline Vehicles data:", error);
    throw error;
  }
};

export { getOfflineVehicles };
